/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FullNameTab
 */
export interface FullNameTab {
    /**
     * The X-coordinate of the fullname on the page, in pixels
     * @type {number}
     * @memberof FullNameTab
     */
    xPosition: number;
    /**
     * The Y-coordinate of the fullname on the page, in pixels
     * @type {number}
     * @memberof FullNameTab
     */
    yPosition: number;
    /**
     * The width of the fullname on the page, in pixels
     * @type {number}
     * @memberof FullNameTab
     */
    width: number;
    /**
     * The height of the fullname on the page, in pixels
     * @type {number}
     * @memberof FullNameTab
     */
    height: number;
    /**
     * The fullname font family
     * @type {string}
     * @memberof FullNameTab
     */
    font: FullNameTabFontEnum;
    /**
     * The fullname font color
     * @type {string}
     * @memberof FullNameTab
     */
    fontColor: FullNameTabFontColorEnum;
    /**
     * The fullname font size
     * @type {string}
     * @memberof FullNameTab
     */
    fontSize: FullNameTabFontSizeEnum;
    /**
     * Indicates whether the fullname is bold
     * @type {boolean}
     * @memberof FullNameTab
     */
    bold: boolean;
    /**
     * Indicates whether the fullname is italic
     * @type {boolean}
     * @memberof FullNameTab
     */
    italic: boolean;
    /**
     * Indicates whether the fullname is underlined
     * @type {boolean}
     * @memberof FullNameTab
     */
    underline: boolean;
    /**
     * The ID of the document where the fullname field is placed
     * @type {string}
     * @memberof FullNameTab
     */
    documentId: string;
    /**
     * The page number of the document where the fullname field is placed
     * @type {number}
     * @memberof FullNameTab
     */
    pageNumber: number;
    /**
     * The fullname value
     * @type {string}
     * @memberof FullNameTab
     */
    value: string;
    /**
     * Indicates whether the signer is required to fill out this field
     * @type {boolean}
     * @memberof FullNameTab
     */
    required: boolean;
    /**
     * Indicates whether the field is locked and cannot be edited by the signer
     * @type {boolean}
     * @memberof FullNameTab
     */
    locked: boolean;
}


/**
 * @export
 */
export const FullNameTabFontEnum = {
    arial: 'arial',
    arialnarrow: 'arialnarrow',
    calibri: 'calibri',
    couriernew: 'couriernew',
    garamond: 'garamond',
    georgia: 'georgia',
    helvetica: 'helvetica',
    lucidaconsole: 'lucidaconsole',
    msgothic: 'msgothic',
    msmincho: 'msmincho',
    tahoma: 'tahoma',
    timesnewroman: 'timesnewroman',
    trebuchet: 'trebuchet',
    verdana: 'verdana',
    unknown_default_open_api: '11184809'
} as const;
export type FullNameTabFontEnum = typeof FullNameTabFontEnum[keyof typeof FullNameTabFontEnum];

/**
 * @export
 */
export const FullNameTabFontColorEnum = {
    black: 'black',
    brightblue: 'brightblue',
    brightred: 'brightred',
    darkgreen: 'darkgreen',
    darkred: 'darkred',
    gold: 'gold',
    green: 'green',
    navyblue: 'navyblue',
    purple: 'purple',
    white: 'white',
    unknown_default_open_api: '11184809'
} as const;
export type FullNameTabFontColorEnum = typeof FullNameTabFontColorEnum[keyof typeof FullNameTabFontColorEnum];

/**
 * @export
 */
export const FullNameTabFontSizeEnum = {
    size7: 'size7',
    size8: 'size8',
    size9: 'size9',
    size10: 'size10',
    size11: 'size11',
    size12: 'size12',
    size14: 'size14',
    size16: 'size16',
    size18: 'size18',
    size20: 'size20',
    size22: 'size22',
    size24: 'size24',
    size26: 'size26',
    size28: 'size28',
    size36: 'size36',
    size48: 'size48',
    size72: 'size72',
    unknown_default_open_api: '11184809'
} as const;
export type FullNameTabFontSizeEnum = typeof FullNameTabFontSizeEnum[keyof typeof FullNameTabFontSizeEnum];


/**
 * Check if a given object implements the FullNameTab interface.
 */
export function instanceOfFullNameTab(value: object): boolean {
    if (!('xPosition' in value)) return false;
    if (!('yPosition' in value)) return false;
    if (!('width' in value)) return false;
    if (!('height' in value)) return false;
    if (!('font' in value)) return false;
    if (!('fontColor' in value)) return false;
    if (!('fontSize' in value)) return false;
    if (!('bold' in value)) return false;
    if (!('italic' in value)) return false;
    if (!('underline' in value)) return false;
    if (!('documentId' in value)) return false;
    if (!('pageNumber' in value)) return false;
    if (!('value' in value)) return false;
    if (!('required' in value)) return false;
    if (!('locked' in value)) return false;
    return true;
}

export function FullNameTabFromJSON(json: any): FullNameTab {
    return FullNameTabFromJSONTyped(json, false);
}

export function FullNameTabFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullNameTab {
    if (json == null) {
        return json;
    }
    return {
        
        'xPosition': json['xPosition'],
        'yPosition': json['yPosition'],
        'width': json['width'],
        'height': json['height'],
        'font': json['font'],
        'fontColor': json['fontColor'],
        'fontSize': json['fontSize'],
        'bold': json['bold'],
        'italic': json['italic'],
        'underline': json['underline'],
        'documentId': json['documentId'],
        'pageNumber': json['pageNumber'],
        'value': json['value'],
        'required': json['required'],
        'locked': json['locked'],
    };
}

export function FullNameTabToJSON(value?: FullNameTab | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'xPosition': value['xPosition'],
        'yPosition': value['yPosition'],
        'width': value['width'],
        'height': value['height'],
        'font': value['font'],
        'fontColor': value['fontColor'],
        'fontSize': value['fontSize'],
        'bold': value['bold'],
        'italic': value['italic'],
        'underline': value['underline'],
        'documentId': value['documentId'],
        'pageNumber': value['pageNumber'],
        'value': value['value'],
        'required': value['required'],
        'locked': value['locked'],
    };
}

